import { render, staticRenderFns } from "./LuxonDateTime.vue?vue&type=template&id=143c1df5"
import script from "./LuxonDateTime.vue?vue&type=script&lang=js"
export * from "./LuxonDateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports